import { render, staticRenderFns } from "./modalFiltroHistorico.vue?vue&type=template&id=f3505b02&scoped=true"
import script from "./modalFiltroHistorico.vue?vue&type=script&lang=js"
export * from "./modalFiltroHistorico.vue?vue&type=script&lang=js"
import style0 from "./modalFiltroHistorico.vue?vue&type=style&index=0&id=f3505b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3505b02",
  null
  
)

export default component.exports